import { FieldValue } from "@atgof-firebase/firebase";
import { DocumentReference } from "@atgof-firebase/types";

export function objectCreationAttributes(userRef: DocumentReference) {
  return {
    deleted: false,
    createdBy: userRef,
    createdAt: FieldValue.serverTimestamp(),
    lastModifiedBy: userRef,
    lastModifiedAt: FieldValue.serverTimestamp(),
  };
}

export function deleteDocument(
  ref: DocumentReference,
  userRef: DocumentReference,
) {
  return ref.update({
    deleted: FieldValue.serverTimestamp(),
    lastModifiedBy: userRef,
  });
}

export function undeleteDocument(
  ref: DocumentReference,
  userRef: DocumentReference,
) {
  return ref.update({ deleted: false, lastModifiedBy: userRef });
}
